import styled from "styled-components";
import { useState } from "react";

// Components
import SimulatorCard from "./simulatorTasks/SimulatorCard";
import Tabs from "./simulatorTasks/Tabs";
import { useEffect } from "react";
import useFetch from "../../../hooks/useFetch";
import { getSimulatorTasks } from "./api/simulator";
import { useSelector } from "react-redux";

const SimulatorTasks = () => {

    const { repo_id } = useSelector((state) => state.auth.user);

    const [tabSelected, setTabSelected] = useState(0);
    const [filteredTasksSelected, setFilteredTasksSelected] = useState([]);

    const {
        data: simulatorTasks,
        loading,
        isError
    } = useFetch({
        asyncFn: () => getSimulatorTasks(repo_id)
    })

    useEffect(() => {
        if (isError || loading) return;
        if (!!simulatorTasks?.detail) return;
        const filteredTasks = simulatorTasks?.filter((task) => {
            if (tabSelected === 0) return true; // Mostrar todos
            if (tabSelected === 1) return task.status === "pending"; // Disponibles
            if (tabSelected === 2) return task.status !== "pending"; // Realizados
            return;
        });
        setFilteredTasksSelected(filteredTasks);
    }, [tabSelected, simulatorTasks]);

    const tabOptions = [
        { id: 0, label: "Todos" },
        { id: 1, label: "Disponibles" },
        { id: 2, label: "Realizados" }
    ]

    return (
        <Container>
            <Tabs tabValue={tabSelected} handleTabValue={setTabSelected} tabOptions={tabOptions} />
            {loading ? (
                <p>
                    Cargando...
                </p>
            ) : isError || !!simulatorTasks?.detail ? (
                <p>No se encontraron sesiones para este usuario</p>
            ) : (
                filteredTasksSelected?.reverse()?.map((task) => (
                    <SimulatorCard key={task.id} task={task} />
                ))
            )}
        </Container>
    )
}

export default SimulatorTasks;

const Container = styled.div`
    width: calc(100% - 4rem);
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem 2rem;
`